module.exports = __webpack_public_path__ + "img/bg8.23e166b4.png";